module.exports = __webpack_public_path__ + "static/fonts/PlayfairDisplay700italic.aa1396bf.ttf";